import React from 'react';

interface Params {
  watchValue: any;
}

export const useScrollReset = ({ watchValue }: Params) => {
  React.useLayoutEffect(() => window.scrollTo(0, 0), [watchValue]);
};
